//we will use material-ui in project
import { Card, CardContent, FormControl, MenuItem, Select } from '@material-ui/core';
import { useState,useEffect } from 'react';
import './App.css';
import InfoBox from './InfoBox';
import Map from './Map';
import Table from "./Table";
import LineGraph from "./LineGraph";
import { sortData ,prettyPrintStat} from './util';
import "leaflet/dist/leaflet.css"

// https://disease.sh/v3/covid-19/countries

//useEffect runs a code based on a given condition ,runs on the first render
function App() {
  const [countries,setCountries]=useState([]);
  const [country,setCountry]=useState('worldwide');     //to keep track of set country in drop down list
  const [countryInfo,setCountryInfo]=useState({});     //to keep track of set country in drop down list
  const [tableData,setTableData]=useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 34.80746, lng: -40.4796 });
  const [mapZoom, setMapZoom] = useState(3);
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");
  useEffect(()=>{
    fetch("https://disease.sh/v3/covid-19/all")
    .then((response)=>response.json())
    .then(data=>{
      setCountryInfo(data);
    });
  },[]);

  useEffect(() => {
    //async-send a request ,wait for it,do something with info
    const getCountriesData=async()=>{
      await fetch("https://disease.sh/v3/covid-19/countries")
      .then((response)=>{
        response.json().then((data)=>{
          const countries=data.map((country)=>(
            {
              name:country.country,
              value:country.countryInfo.iso2
            }
            
          ));
          const sortedData=sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries); //inserting only name and value of country to array

        })
      })

    }
  getCountriesData();
    
    
  }, [])

  const onCountryChange=async (event)=>{
    const countryCode=event.target.value;
    setCountry(countryCode);

    const url=countryCode==="worldwide"?"https://disease.sh/v3/covid-19/all":`https://disease.sh/v3/covid-19/countries/${countryCode}`;

    await fetch(url)
    .then((response) => response.json())
    .then((data)=>{
      setCountry(countryCode);

      //data of individual countries
      setCountryInfo(data);
      setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
        setMapZoom(4);

    });
  

  
    console.log(countryInfo);



  }
  return (
    // BEM nameing convention used 
    <div className="app">
      <div className="app__left">
        <div className="app__header">
        <h1>Covid-19 Tracker</h1>
      {/* we are using formcontrol from material-ui  */}
      <FormControl className="app__dropdown">
        <Select variant="outlined" onChange={onCountryChange} value={country} >
          <MenuItem value="worldwide">Worldwide</MenuItem>
          {/* loop through all the countries and show a drop down list of options */}
            {countries.map((country)=>{
                return <MenuItem value={country.value}>{country.name}</MenuItem>;
             })}
          
          {/* <MenuItem value="worldwide">Worldwide</MenuItem>
          <MenuItem value="worldwide">Worldwide</MenuItem>
          <MenuItem value="worldwide">Worldwide</MenuItem>
          <MenuItem value="worldwide">Worldwide</MenuItem> */}
        </Select>
      </FormControl>

      </div>

{/* infoboxes */}
      <div className="app__stats">
        <InfoBox onClick={(e) => setCasesType("cases")} active={casesType === "cases"} isRed title="Coronavirus Cases" cases={prettyPrintStat(countryInfo.todayCases)} total={countryInfo.cases}/>
        <InfoBox onClick={(e) => setCasesType("recovered")} active={casesType === "recovered"} title="Recovered" cases={prettyPrintStat(countryInfo.todayRecovered)} total={countryInfo.recovered}/>
        <InfoBox onClick={(e) => setCasesType("deaths")}  active={casesType === "deaths"} isRed title="Death" cases={prettyPrintStat(countryInfo.todayDeaths)} total={countryInfo.deaths}/>
      </div>

      <Map countries={mapCountries}
          casesType={casesType} center={mapCenter} zoom={mapZoom}/>


      </div>

      <Card className="app__right">
        <CardContent>
          <h2>Live Cases by Country</h2>
          <Table countries={tableData}/>
          <h2>Worldwide new {casesType}</h2>

          <LineGraph casesType={casesType}/>

        </CardContent>

      </Card>
      
      

      
      
    </div>
  );
}

export default App;
